var Vendd = (function (Vendd) {
    'use strict';

    Vendd.Store = (function (Store) {

        Store.Messages = (function (Messages) {

            Messages.BindControl = function (context) {
                var data = {
                    context: context
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Store.Messages.BindControl', data);
            };
            Messages.BindControl.className = 'Vendd.Store.Messages.BindControl';

            Messages.resetFilters = function () {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Store.Messages.resetFilters');
            };
            Messages.resetFilters.className = 'Vendd.Store.Messages.resetFilters';

            Messages.resetLocationFilters = function () {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Store.Messages.resetLocationFilters');
            };
            Messages.resetLocationFilters.className = 'Vendd.Store.Messages.resetLocationFilters';

            Messages.SetContinent = function (continent) {
                var data = {
                    continent: continent
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Store.Messages.SetContinent', data);
            };
            Messages.SetContinent.className = 'Vendd.Store.Messages.SetContinent';

            Messages.SetCountry = function (country) {
                var data = {
                    country: country
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Store.Messages.SetCountry', data);
            };
            Messages.SetCountry.className = 'Vendd.Store.Messages.SetCountry';

            Messages.SetArea = function (area) {
                var data = {
                    area: area
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Store.Messages.SetArea', data);
            };
            Messages.SetArea.className = 'Vendd.Store.Messages.SetArea';

            Messages.SetCity = function (city) {
                var data = {
                    city: city
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Store.Messages.SetCity', data);
            };
            Messages.SetCity.className = 'Vendd.Store.Messages.SetCity';

            Messages.SetType = function (type) {
                var data = {
                    type: type
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Store.Messages.SetType', data);
            };
            Messages.SetType.className = 'Vendd.Store.Messages.SetType';

            Messages.SetPostalCode = function (postalCode) {
                var data = {
                    postalCode: postalCode
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Store.Messages.SetPostalCode', data);
            };
            Messages.SetPostalCode.className = 'Vendd.Store.Messages.SetPostalCode';

            Messages.UpdateForm = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Store.Messages.UpdateForm', data);
            };
            Messages.UpdateForm.className = 'Vendd.Store.Messages.UpdateForm';

            Messages.CalculateDistances = function (array, source, maxDistance) {
                var data = {
                    array: array,
                    source: source,
                    maxDistance: maxDistance
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Store.Messages.CalculateDistances', data);
            };
            Messages.CalculateDistances.className = 'Vendd.Store.Messages.CalculateDistances';

            Messages.CalculateDistancesSuccess = function (model, sender) {
                var data = {
                    model: model,
                    sender: sender
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Store.Messages.CalculateDistancesSuccess', data);
            };
            Messages.CalculateDistancesSuccess.className = 'Vendd.Store.Messages.CalculateDistancesSuccess';

            Messages.GetAllPartners = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Store.Messages.GetAllPartners', data);
            };
            Messages.GetAllPartners.className = 'Vendd.Store.Messages.GetAllPartners';

            Messages.GetAllPartnersSuccess = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Store.Messages.GetAllPartnersSuccess', data);
            };
            Messages.GetAllPartnersSuccess.className = 'Vendd.Store.Messages.GetAllPartnersSuccess';

            Messages.GetAllPartnersFailure = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Store.Messages.GetAllPartnersFailure', data);
            };
            Messages.GetAllPartnersFailure.className = 'Vendd.Store.Messages.GetAllPartnersFailure';

            Messages.GetCountries = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Store.Messages.GetCountries', data);
            };
            Messages.GetCountries.className = 'Vendd.Store.Messages.GetCountries';

            Messages.GetCountriesSuccess = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Store.Messages.GetCountriesSuccess', data);
            };
            Messages.GetCountriesSuccess.className = 'Vendd.Store.Messages.GetCountriesSuccess';

            Messages.GetCountriesFailure = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Store.Messages.GetCountriesFailure', data);
            };
            Messages.GetCountriesFailure.className = 'Vendd.Store.Messages.GetCountriesFailure';

            Messages.SearchResults = function (searchString) {
                var data = {
                    searchString: searchString
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Store.Messages.SearchResults', data);
            };
            Messages.SearchResults.className = 'Vendd.Store.Messages.SearchResults';

            Messages.SearchResultsSuccess = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Store.Messages.SearchResultsSuccess', data);
            };
            Messages.SearchResultsSuccess.className = 'Vendd.Store.Messages.SearchResultsSuccess';

            Messages.SearchResultsFailure = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Store.Messages.SearchResultsFailure', data);
            };
            Messages.SearchResultsFailure.className = 'Vendd.Store.Messages.SearchResultsFailure';

            Messages.QueryPartners = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Store.Messages.QueryPartners', data);
            };
            Messages.QueryPartners.className = 'Vendd.Store.Messages.QueryPartners';

            Messages.QueryPartnersSuccess = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Store.Messages.QueryPartnersSuccess', data);
            };
            Messages.QueryPartnersSuccess.className = 'Vendd.Store.Messages.QueryPartnersSuccess';

            Messages.QueryPartnersFailure = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Store.Messages.QueryPartnersFailure', data);
            };
            Messages.QueryPartnersFailure.className = 'Vendd.Store.Messages.QueryPartnersFailure';

            return Messages;

        })(Store.Messages || {});

        return Store;

    })(Vendd.Store || {});

    return Vendd;

})(Vendd || {});